
export const GET_ACTIVE_REQUESTS_DELEGATIONS = "GET_ACTIVE_REQUESTS_DELEGATIONS";
export const CLEAR_REQUESTS_DELEGATION = "CLEAR_REQUESTS_DELEGATION";
export const DELETE_REQUEST_DELEGATION = "DELETE_REQUEST_DELEGATION";


export const GET_AVAILABLE_REQUESTS="GET_AVAILABLE_REQUESTS";
export const CLEAR_AVAILABLE_EMPLOYEES = "CLEAR_AVAILABLE_EMPLOYEES";

export const GET_ELIGIBLE_DELEGATE_STRUCTS = "GET_ELIGIBLE_DELEGATE_STRUCTS";
export const CLEAR_ELIGIBLE_DELEGATE_STRUCTS = "CLEAR_ELIGIBLE_DELEGATE_STRUCTS";
export const GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES = "GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES";
export const CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES = "CLEAR_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES";
